module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABrSURBVCiRtZOxDYAwDAQNYgSGYBS2ASZhHEaBHTJCiqMgFlVE3hLXn+S33wYcwGQqPGRgB0ZVdBKwAIMqOicwR0Snnv9DrOdvEJ0ErJT8HUDrIguXmW29KIVHfU/113Lkc8gFkCsXKnnorW7n9pGHnit6MwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-icon.png
// module id = +4qA
// module chunks = 269